import { mapMutations } from 'vuex'

function getTitle(vm) {
    // 组件可以提供一个 `title` 选项
    // 此选项可以是一个字符串或函数
    const { title } = vm.$options
    if (title) {
        return typeof title === 'function' ? title.call(vm) : title
    }
}

const serverTitleMixin = {
    created() {
        const title = getTitle(this)
        if (title) {
            this.$ssrContext.title = title
        }
    }
}

let titles = {}
const clientTitleMixin = {
    mounted() {
        const title = getTitle(this)
        if (title) {
            titles[this.$route.path] = title
            this.setHeaderTitle(title)
        }
    },
    methods: {
        ...mapMutations({
            set_headerTitle: 'SET_HEADERTITLE'
        }),
        setHeaderTitle(title) { // 防止过多同样的标题一起修改
            this.set_headerTitle(title)
        },
        routerMappingTitle() {
            if (titles[this.$route.path]) {
                this.setHeaderTitle(titles[this.$route.path])
            }
        }
    },
    watch: {
        $route(to, from) {
            this.routerMappingTitle()
        }
    }
}

// 可以通过 `webpack.DefinePlugin` 注入 `VUE_ENV`
export default process.env.VUE_ENV === 'server' ? serverTitleMixin : clientTitleMixin
